module.exports = __webpack_public_path__ + "img/past_ranking.fbcab09b.png";